import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import IconSVG from 'svg-inline-react'
import Icon from 'svg-inline-react'
import Select from 'react-select-plus'
import Avatar from 'shared-web/src/components/Avatar'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'
import { Button } from '@driftt/tide-core-legacy'
import 'react-select-plus/dist/react-select-plus.css'
import returnKeySrc from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/keys/return-key.svg'
import arrowKeysSrc from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/keys/updown-arrow.svg'
import ConditionalRender from 'components/shared/ConditionalRender'
import { resolveStatusIcon } from 'components/shared/AgentStatusAvatar'
import './styles.styl'

const InviteTips = () => (
  <div className="invite-select-tips">
    <span className="dsg-Body color-navy-dark">
      <span className="color-navy-extra-dark">
        Key <IconSVG src={arrowKeysSrc} />
      </span>{' '}
      to navigate
    </span>
    <span className="dsg-Body color-navy-dark">
      <span className="color-navy-extra-dark">
        Return <IconSVG src={returnKeySrc} />
      </span>{' '}
      to select
    </span>
  </div>
)

class InviteSelect extends PureComponent {
  static propTypes = {
    value: PropTypes.array /* Currently chosen value */,
    CTA: PropTypes.string /* text for cta */,
    options: PropTypes.array.isRequired /* All the options to be displayed */,
    onChange: PropTypes.func /* fires on input additions and deletes */,
    onNext: PropTypes.func /* what to do on cta click */,
    className: PropTypes.string /* Optional class name to set on the select component */,
    arrow: PropTypes.bool /* Whether to display an arrow for the dropdown */,
    showInviteTips: PropTypes.bool,
    CustomButton: PropTypes.element
  }

  static defaultProps = {
    showInviteTips: true,
    shouldSelectAutofocus: true
  }

  constructor(props) {
    super(props)

    this.state = {
      selectedOptions: props.value || []
    }
  }

  selectDefaults() {
    const defaults = {
      isOpen: true,
      multi: true,
      autofocus: this.props.shouldSelectAutofocus,
      value: this.state.selectedOptions,
      options: this.props.options || this.selectOptions.options,
      onChange: this.handleSelect,
      clearable: false,
      optionRenderer: this.props.optionRenderer || this.renderOption,
      valueRenderer: this.props.valueRenderer || this.renderValue,
      className: 'InviteSelect',
      placeholder: 'Search team or teammate…'
    }

    return Object.assign({}, defaults, this.props.selectOptions)
  }

  findUser = ({ users, id }) => {
    if (users.has(id)) {
      return users.get(id).toJS()
    }
  }

  findTeam = ({ teams, id }) => {
    return teams.find(team => team.id === id)
  }

  renderUserOption = ({ id }) => {
    const user = this.findUser({ users: this.props.users, id })
    return (
      <div className="flex agent-status-avatar-wrapper">
        <Avatar className="agent-status-avatar" size="small" user={user} />

        <div className="agent-status-indicator agent-status-indicator-conversations">
          <Icon src={resolveStatusIcon(user)} />
        </div>

        <span className="user-label">{getDisplayName(user)}</span>
      </div>
    )
  }

  renderTeamOption = ({ id }) => {
    const team = this.findTeam({ teams: this.props.teams, id })

    return (
      <div className="flex team-option">
        <span className="team-label">{team.name}</span>
      </div>
    )
  }

  renderUserValue = ({ id }) => {
    const user = this.findUser({ users: this.props.users, id })
    return (
      <div className="flex agent-status-avatar-wrapper">
        <Avatar className="agent-status-avatar" size="small" user={user} />

        <div className="agent-status-indicator agent-status-indicator-conversations">
          <Icon src={resolveStatusIcon(user)} />
        </div>

        <span className="user-label">{getDisplayName(user)}</span>
      </div>
    )
  }

  renderTeamValue = ({ id }) => {
    const team = this.findTeam({ teams: this.props.teams, id })

    return (
      <div className="flex team-wrapper">
        <span className="team-label">{team.name}</span>
      </div>
    )
  }

  renderTeamsSectionHeader = () => {
    return (
      <div className="section-header with-subtitle">
        <div className="section-title">Team</div>
        <div className="section-subtitle">
          When you add a Team, we’ll round robin the conversation to someone in that group
        </div>
      </div>
    )
  }

  renderTeammatesSectionHeader = () => {
    return (
      <div className="section-header">
        <div className="section-title">Teammate</div>
      </div>
    )
  }

  renderOptionGroupHeader = ({ label }) => {
    if (label === 'Teams') {
      return this.renderTeamsSectionHeader()
    }

    if (label === 'Teammates') {
      return this.renderTeammatesSectionHeader()
    }

    return null
  }

  renderValue = ({ value }) => {
    if (value.type === 'USER') {
      return this.renderUserValue({ id: value.id })
    }

    if (value.type === 'TEAM') {
      return this.renderTeamValue({ id: value.id })
    }

    return null
  }

  renderOption = ({ value, label }) => {
    if (!value) {
      return this.renderOptionGroupHeader({ label })
    }

    if (value.type === 'USER') {
      return this.renderUserOption({ id: value.id })
    }

    if (value.type === 'TEAM') {
      return this.renderTeamOption({ id: value.id })
    }

    return null
  }

  // TODO: Clicking the "X" on one of the values clears all of them. In Prod,
  // we can click the "X" and only remove that value. Worth fixing.
  handleSelect = selectedOptions => {
    const consumerChangeEvent = this.props.onChange || (() => {})

    this.setState(
      {
        selectedOptions: selectedOptions
      },
      consumerChangeEvent.bind(null, selectedOptions)
    )
  }

  handleClick = () => {
    const { onNext } = this.props
    onNext && onNext(this.state.selectedOptions)
  }

  render() {
    const { showInviteTips, CTA } = this.props
    const { selectedOptions } = this.state
    const disabledCTA = Boolean(selectedOptions.length)

    return (
      <div className="InviteSelectContainer users-and-teams">
        <div className="invite-select-wrapper">
          <Select {...this.selectDefaults()} />
          <ConditionalRender condition={showInviteTips}>
            <InviteTips />
          </ConditionalRender>
          {!!CTA && (
            <Button disabled={!disabledCTA} className="invite-submit-button" onClick={this.handleClick}>
              {CTA}
            </Button>
          )}
        </div>
      </div>
    )
  }
}

export default InviteSelect



// WEBPACK FOOTER //
// ./src/scripts/components/shared/InviteSelect/InviteSelectUsersAndTeams/index.js